// src/services/svc.js
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

console.info("[svc.js] loaded (SDK-only callables)");

// Keep region in sync with your deploy
let functions = getFunctions(app, "us-central1");

/** Optionally switch regions at runtime */
export function setFunctionsRegion(region) {
  functions = getFunctions(app, region || "us-central1");
}

/** Core: call callable by name via SDK and return .data */
export async function callCallable(name, payload) {
  const fn = httpsCallable(functions, name);
  const res = await fn(payload ?? {});
  return res?.data;
}

// Public API
export const tlConnect      = (p) => callCallable("tradelockerConnect_v2", p);
export const tlListAccounts = (p) => callCallable("tradelockerListAccounts_v2", p);
export const tlUseAccount   = (p) => callCallable("tradelockerUseAccount_v2", p);
export const tlSyncNow      = (p) => callCallable("tradelockerSyncNow_v2", p);


// // Tradovate API
export const tvConnect      = (p) => callCallable("tradovateConnect", p);
export const tvListAccounts = (p) => callCallable("tradovateListAccounts", p);
export const tvUseAccount   = (p) => callCallable("tradovateUseAccount", p); // 
export const tvSyncNow      = (p) => callCallable("tradovateSyncNow", p);

export const oandaConnect = httpsCallable(functions, 'oandaConnect');
export const syncTradesCallable = httpsCallable(functions, 'syncOandaTrades');


// Webull API
//export const wbConnect = (p) => callCallable("webullConnect", p);
//export const wbListAccounts = (p) => callCallable("webullListAccounts", p);

const api = {
  callCallable,
  tlConnect,
  tlListAccounts,
  tlUseAccount,
  tlSyncNow,
  tvConnect,
  tvListAccounts,
  tvUseAccount,
  tvSyncNow,
  //wbConnect,
  //wbListAccounts,
  //setFunctionsRegion,
};
export default api;


